import React, { useState } from "react";
import "./ActivateForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import * as Yup from "yup";
import { activateURL } from "../../../../Hooks/URL";
import useActivate from "../../../../Hooks/useActivate";

const ActivateSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password is too short !!")
    .required("Password required !!"),
  passwordConfirm: Yup.string()
    .min(8, "Password is too short !!")
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password required !!"),
});

function ActivateForm() {
  const [t, i18n] = useTranslation("common");
  const { token } = useParams();
  const [newObject, setNewObject] = useState({});
  const [goSave, setGoSave] = useState(false);
  const { saveState, loading } = useActivate({
    url: `${activateURL}/${token}`,
    goSave,
    setGoSave,
    newObject,
  });

  return (
    <div className="FormWrapper">
      <Formik
        initialValues={{ password: "", passwordConfirm: "" }}
        validationSchema={ActivateSchema}
        onSubmit={(values) => {
          setNewObject(values);
          setGoSave(true);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form
            className="LoginFormContainer"
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <TextFieldInput
              fullWidth
              name="password"
              type="password"
              placeholder={"Enter your password"}
              className="LoginInput"
              label="Password"
              change={handleChange}
              blur={handleBlur}
              newValue={values.password}
            />
            {errors.password && touched.password && errors.password && (
              <p className="error">
                {errors.password && touched.password && errors.password}
              </p>
            )}

            <TextFieldInput
              fullWidth
              name="passwordConfirm"
              type="password"
              placeholder={"Enter your password again"}
              className="LoginInput"
              label="Confirm Password"
              change={handleChange}
              blur={handleBlur}
              newValue={values.passwordConfirm}
            />
            {errors.passwordConfirm &&
              touched.passwordConfirm &&
              errors.passwordConfirm && (
                <p className="error">
                  {errors.passwordConfirm &&
                    touched.passwordConfirm &&
                    errors.passwordConfirm}
                </p>
              )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimaryButton
                classBtn={"center addButton"}
                btnType={"submit"}
                text={"Activate"}
                loading={loading}
                style={{
                  textTransform: "capitalize",
                  marginTop: "15px",
                  width: "50%",
                  borderRadius: "5px",
                  color: "var(--text-secondary)",
                  backgroundColor: "var(--primary)",
                }}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default ActivateForm;
